import React, { Component } from 'react';
import { FormControl, TextField, Input, InputLabel, InputAdornment } from '@mui/material';
import MyTooltip from '../../../common/tooltip';
import { returnNationality } from '../../../common/actions/returnNationality';
import SelectorCopy from '../../../common/selectorCopy';

import './style.scss';
import Loading from '../../../common/loading';
import { isEmpty, withNavigate } from '../../../utility';

class tabExpanableVpnBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        }
    }

    /**
     * Data la VPN Pass associata alla box (campo privacyPass), vai alla schermata delle VPN Pass portandola nei filtri
     */
    goToVpnPass = (idVpnPass) => {
        this.props.setKeyVpnPassForDetail(idVpnPass);
        this.props.handleNavigation(this.props.navigate, '/vpn/pass');
    }

    render() {
        const { id, description, country, model, platform, version, wiFiPwd, wiFiSSD, privacyPass } = this.props.data;

        return (
            <div className="tabExpanableVpnBox">
                {this.state.isLoading && <Loading />}
                <FormControl>
                    <div className="row">
                        <div className="col-4">
                            <FormControl className='customSelect'>
                                <InputLabel htmlFor="id-pass">ID Vpn Box</InputLabel>
                                <Input
                                    id="id-vpnBox"
                                    value={id}
                                    readOnly
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <SelectorCopy
                                                item={id}
                                                infoNotify={this.props.infoNotify}
                                                noLabel
                                            />
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>
                        <div className="col-4">
                            <TextField
                                value={isEmpty(description) ? '-' : description}
                                label="Descrizione"
                                variant='standard'
                            />
                        </div>

                        <div className="col-4">
                            <TextField
                                value={isEmpty(country) ? '-' : returnNationality(country)}
                                label="Paese"
                                variant='standard'
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <TextField
                                value={isEmpty(model) ? '-' : model}
                                label="Modello"
                                variant='standard'
                            />
                        </div>

                        <div className="col-4">
                            <TextField
                                value={isEmpty(platform) ? '-' : platform}
                                label="Piattaforma"
                                variant='standard'
                            />
                        </div>

                        <div className="col-4">
                            <TextField
                                value={isEmpty(version) ? '-' : version}
                                label="Versione"
                                variant='standard'
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <TextField
                                value={isEmpty(wiFiPwd) ? '-' : wiFiPwd}
                                label="Wifi Password"
                                variant='standard'
                            />
                        </div>

                        <div className="col-4">
                            <TextField
                                value={isEmpty(wiFiSSD) ? '-' : wiFiSSD}
                                label="Wifi SSD"
                                variant='standard'
                            />
                        </div>

                        <div className="col-4">
                            <FormControl className='customSelect'>
                                <InputLabel htmlFor="id-privacyPass">VPN Pass</InputLabel>
                                <Input
                                    id="id-privacyPass"
                                    value={isEmpty(privacyPass) ? '-' : privacyPass}
                                    readOnly
                                    endAdornment={
                                        !isEmpty(privacyPass) &&
                                        <InputAdornment position="end">
                                            <SelectorCopy
                                                item={privacyPass}
                                                infoNotify={this.props.infoNotify}
                                                noLabel
                                            />
                                            <span className="clickGoTo" onClick={() => { this.goToVpnPass(privacyPass) }}>
                                                <MyTooltip
                                                    title="Vai alla VPN Pass Associata"
                                                    position="top"
                                                    content={<i className="fas fa-share-square" style={{ cursor: 'pointer' }}></i>}
                                                />
                                            </span>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>
                    </div>
                </FormControl>
            </div>
        )
    }
}

export default withNavigate(tabExpanableVpnBox);